import { AfterViewInit, Component, inject } from '@angular/core'
import { IonRouterOutlet } from '@ionic/angular/standalone'
import { ION_COMPONENTS } from '@shared/ionic-components'
import { AppFlowService } from '@shared/services/app-flow.service'

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css'],
  imports: [IonRouterOutlet, ION_COMPONENTS],
})
export class AppLayoutComponent implements AfterViewInit {
  appFlowService = inject(AppFlowService)

  async ngAfterViewInit() {
    if (
      typeof window !== 'undefined' &&
      (window as { __PW_SKIP_APP_LAYOUT_STATE_REFRESH__?: boolean }).__PW_SKIP_APP_LAYOUT_STATE_REFRESH__
    ) {
      return
    }

    setTimeout(() => {
      this.appFlowService.getStateApp().subscribe()
    }, 200)
  }
}
